import gql from 'graphql-tag'

export default gql`
  mutation orderTaxTranscripts($loanId: Int!, $documentId: Int!, $resign: Boolean!) {
    orderTaxTranscripts(input: { loanId: $loanId, documentId: $documentId, resign: $resign }) {
      signUrl
    }
  }
`
